import { create } from 'zustand';
import type { IToastMessage, IToastState } from '../interfaces';

/** Global toast queue. The AppShell drains it into PrimeReact's <Toast>. */
export const useToastStore = create<IToastState>((set, get) => ({
  queue: [],
  push(message: IToastMessage) {
    set({ queue: [...get().queue, message] });
  },
  drain() {
    const q = get().queue;
    if (q.length) set({ queue: [] });
    return q;
  },
}));
